"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function defineCmsService(spi) {
    return {
        id: 'cms-service',
        create: () => ({
            '1.3.0': (consumerId, consumerName) => ({
                featureService: {
                    inEditor: spi.inEditor,
                    render: (id, model) => spi.render(consumerId, id, model),
                    mapUrl: spi.mapUrl,
                    createNavigationTarget: spi.createNavigationTarget,
                    openLayer: (path) => {
                        return spi.openLayer(path, consumerName);
                    },
                    getNbabInfo: () => {
                        return spi.getNbabInfo(consumerId);
                    },
                    listenToNbabInfo(listener) {
                        return spi.listenToNbabInfo(consumerId, listener);
                    },
                },
                unbind: () => {
                    spi.cleanup(consumerId);
                },
            }),
        }),
    };
}
exports.defineCmsService = defineCmsService;
//# sourceMappingURL=index.js.map